import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "pl-4 lg:pl-20 py-14 font-poppins" }
const _hoisted_3 = { class: "grid grid-cols-2 lg:grid-cols-4" }
const _hoisted_4 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "col-span-1"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 2,
  class: "col-span-1"
}
const _hoisted_10 = ["href"]

import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Legal',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full bg-legal" }, [
      _createElementVNode("div", { class: "py-20 px-4 lg:px-24" }, [
        _createElementVNode("h1", { class: "font-benzin text-white text-4xl uppercase tracking-wide font-normal mt-28" }, [
          _createTextVNode("Legal "),
          _createElementVNode("br"),
          _createTextVNode("Information")
        ]),
        _createElementVNode("p", { class: "font-poppins text-white text-xl max-w-sm" }, "Everything you need in one place.")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-5" }, "Please find the following legal documents below:", -1)),
          _createElementVNode("div", _hoisted_3, [
            (_unref(legalDocuments).termsOfService.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-2xl mb-5 font-bold" }, "Terms Of Service", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).termsOfService, (legalDocument) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-5",
                      key: legalDocument.name
                    }, [
                      _createElementVNode("a", {
                        href: legalDocument.url,
                        class: "text-black hover:text-black hover:underline transition duration-250",
                        target: "_blank"
                      }, _toDisplayString(legalDocument.name), 9, _hoisted_5)
                    ]))
                  }), 128)),
                  _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-2xl mb-5 font-bold" }, "Critical Information Summaries", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).cis, (cis) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-5",
                      key: cis.name
                    }, [
                      _createElementVNode("a", {
                        href: cis.url,
                        class: "text-black hover:text-black hover:underline transition duration-250",
                        target: "_blank"
                      }, _toDisplayString(cis.name), 9, _hoisted_6)
                    ]))
                  }), 128)),
                  _createVNode(_component_router_link, {
                    to: "/legacy",
                    class: "text-xl mb-5 font-bold underline text-brand-secondary"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Legacy Documents ")
                    ])),
                    _: 1,
                    __: [0]
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(legalDocuments).policies.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-2xl mb-5 font-bold" }, "Policies", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).policies, (legalDocument) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-5",
                      key: legalDocument.name
                    }, [
                      _createElementVNode("a", {
                        href: legalDocument.url,
                        class: "text-black hover:text-black hover:underline transition duration-250",
                        target: "_blank"
                      }, _toDisplayString(legalDocument.name), 9, _hoisted_8)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(legalDocuments).formsAndGuides.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-2xl mb-5 font-bold" }, "Forms & Guides", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(legalDocuments).formsAndGuides, (legalDocument) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-5",
                      key: legalDocument.name
                    }, [
                      _createElementVNode("a", {
                        href: legalDocument.url,
                        class: "text-black hover:text-black hover:underline transition duration-250",
                        target: "_blank"
                      }, _toDisplayString(legalDocument.name), 9, _hoisted_10)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})